// Contexts for scene views and move replay, kept apart from the components so bricks can read
// them without importing the brick host.

import { createContext, useContext } from 'react';
import type { Tab, NavigationEntry } from './tabs';
import type { Material } from '../presentation/types';
import type { ReplayMarks, ReplayStop } from '../motion/replay';

export interface ViewsApi {
  tabs: Tab[];
  current: string | null;
  select: (key: string) => void;
  navigation?: NavigationEntry[];
  /** `choices`: badges count distinct lit choices, not anchors (see `Views.badges`). */
  badges?: 'choices';
  /** Tab panel surface. */
  material: Material;
  tint?: string;
}

export const ViewsContext = createContext<ViewsApi | null>(null);
export const useViews = () => useContext(ViewsContext);

/** Replay state shared by the log feed, pieces and overlays. */
export interface ReplayApi {
  /** The stop on show, or null when live. */
  stop: ReplayStop | null;
  marks: ReplayMarks | null;
  enter: (revision: number) => void;
  exit: () => void;
}

const ReplayContext = createContext<ReplayApi | null>(null);
export const ReplayProvider = ReplayContext.Provider;
export const useReplay = () => useContext(ReplayContext);
